import { apiFetch } from './api';

export function selectAttachments(fileList) {
  const files = [...fileList];
  if (files.length > 3) throw new Error('Selecione até três comprovantes.');
  for (const file of files) {
    if (!/\.(pdf|png|jpe?g)$/i.test(file.name)) throw new Error('Selecione arquivos PDF, JPG ou PNG.');
    if (!file.size || file.size > 10 * 1024 * 1024) throw new Error('Cada arquivo deve ter conteúdo e no máximo 10 MB.');
  }
  return files.map(file => ({ file, id: crypto.randomUUID() }));
}
export async function uploadAttachments(expenseId, files, onUploaded = async () => {}) {
  for (const entry of files) {
    await apiFetch(`/frota/despesas/${expenseId}/anexos`, {
      method: 'POST', headers: { 'Content-Type': 'application/octet-stream', 'X-Upload-Id': entry.id, 'X-File-Name': encodeURIComponent(entry.file.name) }, body: entry.file,
    });
    await onUploaded(entry);
  }
}
